import React from "react";
import Spinner from "../../../presentation/spinner";
import "./style.css";

export default () => {
  return (
    <div className="outer-spinner-and-text-wrapper">
      <div className="spinner-and-text-wrapper">
        <Spinner size={150} />
        <p>Loading Project and Now Ready Configuration</p>
      </div>
    </div>
  );
};
